module.exports = __webpack_public_path__ + "img/96758.1d8f81a9.svg";